<template>
    <div>
        <div class="edit-title">资源配置</div>
        <el-tag :key="index" v-for="(tag, index) in dynamicTags" :closable="!getDisabled" :type="selectDataIndex==index?'':'info'" :disable-transitions="false" @click="selectData(index,tag)" @close="handleClose(tag)">
            {{tag.name}}
        </el-tag>
        <el-input class="input-new-tag" v-if="inputVisible" maxlength="50" v-model="inputValue" ref="saveTagInput" size="small" style="width: 300px;" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm" placeholder="请输入Topic名称">
        </el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 新增Topic</el-button>
        <div v-for="(tag, index) in dynamicTags" class="box-dynamicTags">
            <!-- 搜索 -->
            <div class="search_box" v-if="selectDataIndex == index">
                <el-form :model="tag" ref="ruleForm" label-width="100px" class="demo-ruleForm" inline :disabled="getDisabled">
                    <el-form-item label="Topic名称:" prop="name" :rules="[
                        {required: true, message: '名称不能为空',trigger: 'blur'},
                        {min: 1, max: 50, message: '名称不能超过50个字符', trigger: 'blur'}
                    ]">
                        <el-input v-model="tag.name" placeholder="名称不能超过50个字符" maxlength="50" :disabled="!isTopicEdit"></el-input>
                    </el-form-item>
                    <el-form-item label-width="0px" label=" ">
                        <el-button :type='isTopicEdit?"success": "primary"' class="button-new-tag" style="margin-left: -10px;" size="small" @click="editTopClick">{{ isTopicEdit ? "保存" : "修改" }}</el-button>
                    </el-form-item>
                    <el-button class="button-new-tag floatButton" size="small" type="primary" @click="addForm">+ 新增Partition</el-button>
                </el-form>
            </div>
            <!-- table -->
            <el-table :data="tableData" border v-if="selectDataIndex == index" highlight-current-row :header-cell-style="{ background: '#f2f2f2' }">
                <el-table-column label="序号" type="index" align="center" width="100">
                </el-table-column>
                <el-table-column prop="id" label="Partition编号" align="center">
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.editStatus" v-model="scope.row.num" placeholder="Partition编号"></el-input>
                        <span v-if="!scope.row.editStatus">{{scope.row.num}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button @click="editTable(scope.row)" v-if="!scope.row.editStatus" type="primary" size="small">编辑
                        </el-button>
                        <el-button @click="saveTable(scope.row, scope.$index)" v-if="scope.row.editStatus" type="success" size="small">保存
                        </el-button>
                        <el-button @click="concelAddTable(scope.row)" v-if="scope.row.editStatus" size="small">取消
                        </el-button>
                        <el-button @click="deleteTable(scope.row)" type="error" size="small" v-if="!scope.row.editStatus">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import {
    getListByKafkaClusterID,
    deleteTopic,
    addOrEditPipelineTopic,
    deletePartition,
    addOrEditPartition,
    getListByTopicID,
    addOrEditKafka
} from "@/apis/pipelineService/kafkaService";
export default {
    data() {
        return {
            aaa: "",
            isTopicEdit: false, // 是否修改Topic
            moduleName: "",
            inputValue: "", // 输入框input
            dynamicTags: [],
            inputVisible: false,
            selectDataIndex: 0, // 选中key
            selectValue: {}, // 选中value
            tableData: [], // table列表
            isFlag: false // 防止重复请求接口
        };
    },
    mounted() {
        if (this.$route.query.type != "add") {
            this.getListByKafkaClusterID(); // 加载toppic列表
        }
    },
    computed: {
        getDisabled() {
            return {
                add: false,
                edit: false,
                details: true
            }[this.$route.query.type];
        }
    },
    methods: {
        // 新增Table按钮
        addForm() {
            if (!this.selectValue.id || !this.selectValue.name) {
                this.$message.error("请先填写Topic名称");
                return false;
            }
            let obj = {};
            this.tableData.push({
                num: "",
                editStatus: true
            });
        },
        // 删除Topic
        handleClose(tag) {
            this.deleteData(tag, "Topic");
        },
        showInput() {
            this.inputValue = "";
            this.isFlag = false; // 防止重复请求接口
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        // 新增Topic 按钮
        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue && !this.isFlag) {
                this.isFlag = true; // 防止重复请求接口
                this.addOrEditPipelineTopic("add");
            } else {
                this.inputVisible = false;
            }
        },
        // 修改Topic 按钮
        editTopClick() {
            this.isTopicEdit = !this.isTopicEdit;
            if (!this.isTopicEdit) {
                this.addOrEditPipelineTopic("edit");
            }
        },
        // 编辑table
        editTable(data) {
            this.$set(data, "editStatus", true);
        },
        // 保存table
        saveTable(data, index) {
            if (!data.num) {
                this.$message.error("Partition编号不能为空！");
                return false;
            }
            let num = +data.num;
            if (num !=0 && !num) {
                this.$message.error("Partition编号为数字！");
                return false;
            }
            this.addOrEditPartition(data, index);
        },
        // 删除table
        deleteTable(data) {
            this.deleteData(data, "Partition");
        },
        // 选择Topic
        selectData(index, tag) {
            if (this.selectDataIndex == index) {
                return false;
            }
            this.tableData = [];
            this.selectDataIndex = index;
            this.selectValue = tag;
            this.getListByTopicID(); // 获取当前Topic下的Partition
        },
        // 获取topic列表
        async getListByKafkaClusterID() {
            let params = {
                kafkaClusterID: this.$route.query.id // 集群id
            };
            try {
                const data = await getListByKafkaClusterID(params);
                if (data.code == 0 && data.data) {
                    this.dynamicTags = data.data;
                    if (this.dynamicTags && this.dynamicTags.length > 0) {
                        this.selectValue = this.dynamicTags[0];
                        this.selectDataIndex = 0;
                        this.getListByTopicID();
                    }
                }
            } catch (error) {}
        },
        // 根据topicId获取Partition列表
        async getListByTopicID() {
            let params = {
                topicID: this.selectValue.id
            };
            try {
                const data = await getListByTopicID(params);
                if (data.code == 0 && data.data) {
                    this.tableData = data.data;
                }
            } catch (error) {}
        },
        // 新增或修改topic
        async addOrEditPipelineTopic(type) {
            let params = {
                kafkaId: +this.$route.query.id,
                name: type == "add" ? this.inputValue : this.selectValue.name,
                id: type == "add" ? "" : this.selectValue.id
            };
            if (type == "add") {
                delete params.id;
            }
            try {
                const data = await addOrEditPipelineTopic(params);
                if (data.code == 0) {
                    if (type == "add") {
                        this.dynamicTags.push({
                            name: this.inputValue,
                            id: data.data.id
                        });
                        this.inputVisible = false;
                        this.selectDataIndex = this.dynamicTags.length - 1;
                        this.selectValue = this.dynamicTags[
                            this.selectDataIndex
                        ];
                        this.tableData = [];
                    } else {
                        this.$message.success(data.message || "修改成功");
                    }
                } else {
                    this.$message.error(data.message || "保存失败");
                    this.inputValue = null;
                    this.inputVisible = false;
                }
            } catch (error) {}
        },
        // 新增或修改Partition保存
        async addOrEditPartition(data, index) {
            let params = {
                topicId: this.selectValue.id,
                num: +data.num,
                id: data.id
            };
            if (!data.id) {
                delete params.id;
            }
            try {
                const res = await addOrEditPartition(params);
                if (res.code == 0) {
                    this.$message.success(res.message || "保存成功");
                    this.$set(this.tableData[index], "editStatus", false);
                    this.$set(
                        this.tableData[index],
                        "id",
                        data.id || res.data.id
                    );
                    this.$set(this.tableData[index], "num", +data.num);
                } else {
                    this.$message.error(res.message || "保存失败");
                }
            } catch (error) {}
        },
        // 删除提示
        deleteData(data, type) {
            this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    if (type == "Topic") {
                        this.deleteTopic(data);
                    } else {
                        this.deletePartition(data);
                    }
                })
                .catch(() => {});
        },
        // 删除Topic接口
        async deleteTopic(tag) {
            const params = {
                id: tag.id
            };
            try {
                const data = await deleteTopic(params);
                if (data.code == 0) {
                    this.$message.success(data.message || "删除成功");
                    this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
                    this.getListByKafkaClusterID();
                } else {
                    this.$message.error(data.message || "删除失败");
                }
            } catch (error) {}
        },
        // 删除Partition接口
        async deletePartition(tag) {
            const params = {
                id: tag.id,
                topicId: this.selectValue.id
            };
            try {
                const data = await deletePartition(params);
                if (data.code == 0) {
                    this.$message.success(data.message || "删除成功");
                    this.tableData.splice(this.tableData.indexOf(tag), 1);
                } else {
                    this.$message.error(data.message || "删除失败");
                }
            } catch (error) {}
        },
        // 取消添加Partition
        concelAddTable(data) {
            if (data.id) {
                this.$set(data, "editStatus", false);
                this.getListByTopicID();
            } else {
                this.tableData.splice(this.tableData.indexOf(data), 1);
            }
        }
    }
};
</script>
<style lang="less" scoped>
.search_box {
    padding-top: 20px;
}
.el-tag + .el-tag {
    margin-left: 10px;
}
.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}
.info {
    width: 100%;
    margin: 0 auto;
    background: #f8f8f8;
    border-radius: 10px;
    padding-top: 20px;
    margin-bottom: 20px;
}
h5 {
    font-size: 18px;
    padding: 15px;
    font-weight: 700;
    color: #666;
    border-bottom: 1px solid #ddd;
    margin-bottom: 40px;
}
.edit-title {
    margin-top: 40px;
}
.buttonMarginClass {
    margin-left: 20px;
}
.floatButton {
    float: right;
}
.box-dynamicTags {
    margin-bottom: 30px;
}
</style>

